module.exports = __webpack_public_path__ + "static/media/ch.866ea121.svg";